import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_accessorial_charges_templates_activityService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { full_text_search?: string, top?: number, skip?: number }): 
  Promise<{ result: { Id?: number, BillingAccessorialChargeTemplate?: { LookupCode?: string }, OperationCode?: { Name?: string, BillingTasks?: { Id?: number, AccessorialTask?: { CompletedDateTime?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, Notes?: string, Status?: { Id?: number, Name?: string } } }[] } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { full_text_search?: string, top?: number, skip?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, BillingAccessorialChargeTemplate?: { LookupCode?: string }, OperationCode?: { Name?: string, BillingTasks?: { Id?: number, AccessorialTask?: { CompletedDateTime?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, Notes?: string, Status?: { Id?: number, Name?: string } } }[] } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { full_text_search?: string, top?: number, skip?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, BillingAccessorialChargeTemplate?: { LookupCode?: string }, OperationCode?: { Name?: string, BillingTasks?: { Id?: number, AccessorialTask?: { CompletedDateTime?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, Notes?: string, Status?: { Id?: number, Name?: string } } }[] } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      full_text_search?: string, top?: number, skip?: number    }) {
      return false;
    }
}
